document.addEventListener('DOMContentLoaded', () => {
  const url = new URL(window.location.href)
  const voucher = url.searchParams.get('voucher')

  if (voucher) {
    const data = new FormData()
    data.append('voucher', voucher)

    fetch('/basket', {
      method: 'post',
      body: data,
    }).then((response) => {
      if (!response.url.includes('wrong_voucher=1')) {
        const voucherText = document.getElementById('js-voucher')
        voucherText.innerHTML = voucher

        const voucherModal = document.getElementById('js-voucher-added')
        if (voucherModal) {
          voucherModal.classList.add('modal--open')
        }
      }
    })
  }
})
